export class Constants {
  // public static basePath= "http://localhost:3000";
  // public static basePath = "https://uat.api.subtraid.com";
  // public static basePath = "http://3.111.69.255:3000";
  public static basePath = "https://eduversity.ai:3000";
}